import type {
	ScreenerColumn,
	ScreenerData,
	ScreenerSubField,
} from "epsm-api-types/models";
import { DEFAULT_ROWS_LIMIT } from "@/components/widgets/Screener/default";
import ErrorHandler from "@/services/ErrorService/ErrorService";
import { exportCsv } from "@/shared/helpers/exportCsv";
import type { FieldParams } from "@/shared/helpers/generateCSV";
import { generateCSV } from "@/shared/helpers/generateCSV";
import { getColumnTitle } from "../getColumnTitle";

export const exportCsvData = (
	visibleColumns: ScreenerColumn[],
	data: ScreenerData[],
	name: string,
) => {
	return () => {
		try {
			const params: Record<keyof ScreenerData, FieldParams> = {};

			const processNestedSubfields = (
				column: ScreenerColumn,
				subFields: ScreenerSubField[],
				parentName: string,
				parentTitle: string,
			) => {
				for (const subfield of subFields) {
					const fullColumnName = `${parentName}.${subfield.name}`;
					const fullTitle =
						parentName === column.name
							? getColumnTitle(subfield, true)
							: `${parentTitle} > ${getColumnTitle(subfield, true)}`;

					if (subfield.subFields?.length) {
						processNestedSubfields(
							column,
							subfield.subFields,
							fullColumnName,
							fullTitle,
						);
					} else {
						params[fullColumnName] = {
							header: `${getColumnTitle(column)} (${fullTitle})`,
							column,
						};
					}
				}
			};

			for (const column of visibleColumns) {
				const columnName = column.name;

				if (column.subFields?.length) {
					processNestedSubfields(
						column,
						column.subFields,
						columnName,
						getColumnTitle(column),
					);
				} else {
					params[column.name] = {
						header: getColumnTitle(column),
						column,
					};
				}
			}

			const csv = generateCSV({
				data: name.toLowerCase().includes("monitor")
					? data
					: data.slice(0, DEFAULT_ROWS_LIMIT),
				params,
			});
			exportCsv(csv, name);
		} catch (error) {
			ErrorHandler.logError(error);
		}
	};
};
